export default __webpack_public_path__ + "static/media/smallLogo.858b3a05.png";